module.exports = __webpack_public_path__ + "static/media/jobs.f6004de6.xlsx";